module.exports = __webpack_public_path__ + "images/emoji/envelope_with_arrow.603c92186765a02af306.png";